/**
 * Misma regla que el menú y los guardas de página.
 * Historial General sigue limitado al correo que ya lo abre hoy.
 * Subir documentos sigue limitado a administrador y usuario.
 */

export const CORREO_HISTORIAL_GENERAL = 'admin@induma.com.co'

export function usuarioDeSesion() {
  try {
    const raw = localStorage.getItem('user') || sessionStorage.getItem('user')
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

function normalizarRuta(ruta) {
  const path = String(ruta || '').split('?')[0].split('#')[0]
  if (path.length > 1 && path.endsWith('/')) return path.slice(0, -1)
  return path || '/'
}

export function puedeAbrirRuta(ruta, usuario = usuarioDeSesion()) {
  if (!usuario) return false
  const path = normalizarRuta(ruta)
  const role = usuario.role || ''
  const admin = role === 'administrador' || Boolean(usuario.is_admin)
  const supervisor = role === 'supervisor'
  const rolUsuario = role === 'usuario'

  if (path === '/historial-general') return usuario.email === CORREO_HISTORIAL_GENERAL
  if (path === '/editor') return admin || rolUsuario
  if (path.startsWith('/editor/')) return !supervisor
  if (path === '/users') return admin || supervisor
  if (
    path === '/config' ||
    path === '/config/email' ||
    path === '/config/database' ||
    path === '/config/pdf-visual' ||
    path === '/config/bulk-download'
  ) {
    return admin || supervisor
  }
  if (
    path === '/dashboard' ||
    path === '/documentos-pendientes' ||
    path === '/firmados-pendientes' ||
    path === '/config/signature' ||
    path.startsWith('/ver-documento/')
  ) {
    return true
  }
  return true
}
